// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountTypeDto
 */
export interface IAccountTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountTypeDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountTypeDto
     */
    type_code?: string;
}

/**
 * Check if a given object implements the IAccountTypeDto interface.
 */
export function instanceOfIAccountTypeDto(value: object): value is IAccountTypeDto {
    return true;
}

export function IAccountTypeDtoFromJSON(json: any): IAccountTypeDto {
    return IAccountTypeDtoFromJSONTyped(json, false);
}

export function IAccountTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'type_code': json['type_code'] == null ? undefined : json['type_code'],
    };
}

export function IAccountTypeDtoToJSON(json: any): IAccountTypeDto {
    return IAccountTypeDtoToJSONTyped(json, false);
}

export function IAccountTypeDtoToJSONTyped(value?: IAccountTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'type_code': value['type_code'],
    };
}

